/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Challenge_LabelInputs */

const es_home_usecases_challenge_label = /** @type {(inputs: Home_Usecases_Challenge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El desafío`)
};

const en_home_usecases_challenge_label = /** @type {(inputs: Home_Usecases_Challenge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The challenge`)
};

/**
* | output |
* | --- |
* | "The challenge" |
*
* @param {Home_Usecases_Challenge_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_challenge_label = /** @type {((inputs?: Home_Usecases_Challenge_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Challenge_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_challenge_label(inputs)
	return en_home_usecases_challenge_label(inputs)
});
export { home_usecases_challenge_label as "home.usecases.challenge_label" }